import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FE08919F-CFFC-4A25-994C-CEDEB299908B
 * name bank
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank.svg
 * tags
 * - Banking 
 * - Places 
 */
export const BankIcon = createSvgIcon(<><path d="M11.5,1L2,6V8H21V6M16,10V17H19V10M2,22H21V19H2M10,10V17H13V10M4,10V17H7V10H4Z" /></>, 'BankIcon');
export default BankIcon